var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.08 21.522c.02 2.48-.688 4.92-2.027 6.986a12.497 12.497 0 0 1-5.52 4.674 12.215 12.215 0 0 1-7.154.778 12.343 12.343 0 0 1-6.376-3.385 12.595 12.595 0 0 1-3.444-6.396c-.502-2.43-.276-4.96.65-7.262a12.43 12.43 0 0 1 4.516-5.668 12.276 12.276 0 0 1 6.868-2.175h.109c1.623 0 3.227.305 4.723.925a12.404 12.404 0 0 1 4.015 2.686 12.565 12.565 0 0 1 2.696 4.035 12.64 12.64 0 0 1 .964 4.772v.02l-.02.01z",
    fill: "#F59D1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.789 21.522a12.75 12.75 0 0 1-2.027 6.996 12.496 12.496 0 0 1-5.52 4.674 12.213 12.213 0 0 1-7.154.778 12.341 12.341 0 0 1-6.377-3.385 12.597 12.597 0 0 1-3.444-6.396c-.501-2.43-.275-4.96.65-7.262a12.429 12.429 0 0 1 4.517-5.668 12.276 12.276 0 0 1 6.868-2.175h.108c1.624 0 3.228.305 4.723.925a12.402 12.402 0 0 1 4.015 2.686 12.566 12.566 0 0 1 2.696 4.035 12.64 12.64 0 0 1 .965 4.772v.02h-.02z",
    fill: "#E7001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.046 11.73a12.287 12.287 0 0 0-3.493 4.34 12.474 12.474 0 0 0-1.25 5.461c0 1.9.423 3.76 1.25 5.462a12.31 12.31 0 0 0 3.493 4.339 12.426 12.426 0 0 0 3.503-4.34 12.475 12.475 0 0 0 1.25-5.46c0-1.9-.423-3.76-1.25-5.462a12.228 12.228 0 0 0-3.503-4.34z",
    fill: "#FC5F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.f18106f345df77f6ed850714e5346c4e.svg";
export { ForwardRef as ReactComponent };